import type { SessionUser } from '@apen/shared';
import { useTrocarBanco } from '../../hooks/useEmpresas';
import { useFeedback } from '../Feedback/FeedbackProvider';
import { ApiRequestError } from '../../lib/api';
import s from './AppShell.module.css';

/**
 * Banco de trabalho, no topo, ao lado da empresa.
 *
 * Decide de qual banco sao o Extratos, a classificacao e as travas. As telas
 * analiticas continuam somando todos os bancos visiveis. Com um banco so ele
 * nao aparece, e so admin ve: para os demais o banco de lancamento e definido
 * pelo admin em Usuarios, porque escolher banco e escolher onde escrever.
 */
export function SeletorBanco({ session }: { session: SessionUser | null | undefined }) {
  const trocar = useTrocarBanco();
  const feedback = useFeedback();
  const bancos = session?.banks ?? [];
  if (bancos.length < 2 || session?.role !== 'admin') return null;

  async function escolher(id: number) {
    const nome = bancos.find((b) => b.id === id)?.name ?? '';
    try {
      await trocar.mutateAsync(id);
      feedback.success('Banco trocado.', `Agora você está trabalhando no ${nome}.`);
    } catch (erro) {
      feedback.error(
        'Não foi possível trocar de banco',
        erro instanceof ApiRequestError ? erro.message : undefined,
      );
    }
  }

  return (
    <label className={s.empresaChip} title="Banco de trabalho">
      <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
        <path d="M3 10l9-6 9 6" />
        <path d="M5 10v8M9.5 10v8M14.5 10v8M19 10v8" />
        <path d="M3 21h18" />
      </svg>
      <span className={s.srOnly}>Banco de trabalho</span>
      <select
        className={s.empresaSelect}
        value={session?.classification_bank_id ?? ''}
        disabled={trocar.isPending}
        onChange={(e) => void escolher(Number(e.target.value))}
      >
        {session?.classification_bank_id == null ? (
          <option value="" disabled>
            Escolha o banco
          </option>
        ) : null}
        {bancos.map((banco) => (
          <option key={banco.id} value={banco.id}>
            {banco.name}
          </option>
        ))}
      </select>
    </label>
  );
}
